import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';

import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NotificationErrorService } from 'src/app/modules/acbcr/common/services/notification-error.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {


  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(
    private router: Router,
    private errorService: NotificationErrorService,
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (localStorage['access-token']) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${localStorage['access-token']}`)
      });
    }

    return next.handle(request).pipe(
      tap({
        next: (response) => {
        },
        error: (errors) => {
          if (errors.status === 403) {
            this.router.navigateByUrl('/login');
            localStorage.removeItem('access-token');

            return;
          }

          if (errors.error instanceof Blob) {
            let blobToTextPromise = errors.error.text();
            blobToTextPromise.then((text: string) => {
              this.errorService.processErrorMsg(
                this.textToJson(text) || 'A apărut o eroare'
              );
            })

            return;
          }

          let errorText;

          if (errors.error instanceof Object) {
            if (errors.error.field_errors) {
              return;
            }

            errorText = errors.error.error;
          } else if (typeof errors.error === 'string') {
            errorText = errors.error;
          }

          if (!errorText && errors.url.includes('/upload')) {
            errorText = 'Fișierul este prea mare';
          }

          if (!errorText) {
            errorText = 'A apărut o eroare';
          }

          this.errorService.processErrorMsg(errorText);
        }
      })
    )
  }

  textToJson(text) {
    let jsonObj: Object;

    try {
      jsonObj = JSON.parse(text);
    } catch (e) {
      return;
    }

    return jsonObj['error'];
  }
}
